import React from 'react';

interface IContainer {
  children?: any;
  style?: React.CSSProperties;
}

const Container = ({
  children,
  style,
}: IContainer) => (
  <div 
    style={{
      ...style,
      width: '100%',
      paddingLeft: 'auto',
      paddingRight: 'auto',
    }}
  >
    {children}
  </div>
);

export default Container;
